<script lang="ts">
    type Image = {
        url?: string;
        srcset?: string;
        width?: number;
        height?: number;
        description?: string;
    };

    export let imgLeft: Image;
    export let imgRight: Image;
</script>

<section class="grid grid-cols-1 gap-5 lg:grid-cols-2">
    {#each [imgLeft, imgRight] as img, index}
        <figure
            class={`flex h-full flex-col gap-1 lg:max-w-[90vw] lg:flex-row ${
                index === 0 ? 'lg:justify-self-end' : 'lg:justify-self-start'
            } `}
        >
            <img
                class={`w-auto max-w-full shrink object-contain max-h-[80vh]`}
                src={img.url}
                srcset={img.srcset}
                width={img.width}
                height={img.height}
                alt={img.description}
                loading="lazy"
            />
            {#if img.description}
                <figcaption
                    class="lg:writing-mode-bt max-h-[80vh] text-center text-xs leading-3 lg:py-5"
                >
                    {img.description}
                </figcaption>
            {/if}
        </figure>
    {/each}
</section>
